export default __webpack_public_path__ + "static/media/sd-pop-2.23300ee3.jpg";